module.exports = __webpack_public_path__ + "static/media/startup.3f4c5658.png";